<template>
  <pagination-controls
    :show="show"
    :text="text"
    :can-prev="canPrev"
    :can-next="canNext"
    @prev="$emit('prev')"
    @next="$emit('next')"
  />
</template>

<script>
import PaginationControls from '../PaginationControls.vue';

export default {
  name: 'SectionPaginationFooter',

  components: {
    PaginationControls
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    canPrev: {
      type: Boolean,
      default: false
    },
    canNext: {
      type: Boolean,
      default: false
    }
  }
};
</script>

